import '../css/PaymentProviderInfo.css'

const PaymentProviderInfo = () => {
    return (
        <div className="text-center mt-3">
            <p className="paymentProviderInfo">Płatności obsługuje Przelewy24.pl - dostępne przelewy online oraz BLIK</p>
        </div>
    )
}

export default PaymentProviderInfo;